/**
 * documentCategoryRenderer — WSPÓLNY renderer pola core `category_id` dla klas dokumentów
 * (kartoteka_key='documents'). Wszystkie 7 klas dzieli JEDNĄ pulę kategorii (jedna tabela
 * `documents`, oś `record_categories` — migracja 0129), więc renderer jest jeden; parametryzuje
 * go wyłącznie kształt stanu (każdy `*FormData` niesie `categoryId: string | null`) i prefiks
 * testid z configu silnika. Mirror `categoryRenderer` z `contractorEngineConfig.tsx`.
 *
 * `RecordCategoryPicker` rysuje własny `<Field>` (label + dropdown), więc renderer nie owija go
 * drugi raz. Używany przez configi silnika formatek klas dokumentów, które trzymają renderery w
 * kontrakcie `FieldRenderer` (pismo/umowa/handlowe/wewnętrzne). Faktury mają WŁASNY kontrakt
 * renderera (`InvoiceRenderer` — `set`/`setMany`), więc tam kategoria wpina się osobnym adapterem.
 */

import type { FieldRenderer } from '@/components/kartoteki/engine/engine-config';
import { RecordCategoryPicker } from '@/components/record-categories/RecordCategoryPicker';

export function makeDocumentCategoryRenderer<
  TForm extends { categoryId: string | null },
  TExtra = undefined,
>(): FieldRenderer<TForm, TExtra> {
  return (ctx) => (
    <RecordCategoryPicker
      kartotekaKey="documents"
      value={ctx.form.categoryId}
      onChange={(next) => ctx.setField({ categoryId: next } as Partial<TForm>)}
      editable={ctx.editable}
      testId={`${ctx.testIdPrefix}-category`}
    />
  );
}
